module.exports = __webpack_public_path__ + "img/cadastro-pecas.fb4d7e0c.jpg";